import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/home',
    meta: {
        title: 'A place to call home | Child Poverty',
    },
    title: 'A place to call home',
    intro: oneLine`High housing costs contribute to many families living in poverty. More than <b>30%</b> of the 
        lowest income households with children spend more than half of their income on housing costs.`,
    image: {
        filename: 'Home.png',
        alt: '',
    },
    content: [
        oneLine`<p>To fix this disparity, the Government needs to continue increasing the supply of social housing and 
            work with community-based housing providers to create a broader range of ownership and renting options.</p>`,
    ],
};

export default data;
